<template>
    <d-card v-if="userInfo.created_at" class="card-small mb-4 pt-3">
        <!-- Card Header -->
        <d-card-header class="border-bottom text-center">
            <!-- User Avatar -->
            <div class="mb-3 mx-auto">
                <div class="profile-icon">
                    <span class="letter-icon">{{ userInfo.first_name | firstLetter }}{{ userInfo.last_name | firstLetter }}</span>
                </div>
            </div>
            <!-- User Name -->
            <h4 class="mb-0">{{ userInfo.full_name }}</h4>
            <!-- User Job Title -->
            <span class="text-muted d-block mb-2">User profile</span>
        </d-card-header>
        <d-list-group flush>
            <!-- User Meta -->
            <d-list-group-item>
                <d-form id="passwordForm" @submit.prevent="updatePassword">
                    <d-form-row>
                        <d-col class="mb-3">
                            <d-form-text tag="h5" class="m-0">Edit password</d-form-text>
                            <br>
                            Please use the form below to change your current password.
                            <br>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="12" class="form-group">
                            <label for="oldPassword">Old Password</label>
                            <d-input type="password" v-model="oldPassword" id="oldPassword" placeholder="password" />
                        </d-col>
                        <d-col md="12" class="form-group">
                            <label for="newPassword">New Password</label>
                            <d-input type="password" v-model="newPassword" id="newPassword" placeholder="password" />
                        </d-col>
                        <d-col md="12" class="form-group">
                            <label for="repeatPassword">Repeat New Password</label>
                            <d-input type="password" v-model="repeatPassword" id="repeatPassword" placeholder="repeat password" />
                        </d-col>
                        <p v-if="error.length" v-for="message in error">
                            <b class="text-danger">{{ message[0] }}</b>
                        </p>
                        <p v-if="success.length">
                            <b class="text-success">{{ success }}</b>
                        </p>
                    </d-form-row>
                </d-form>
            </d-list-group-item>
        </d-list-group>
        <d-card-footer class="border-top d-flex justify-content-end">
            <input form="passwordForm" value="Save Password" type="submit" class="btn btn-accent">
        </d-card-footer>
    </d-card>
</template>

<script>
    import { UserService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
                error: [],
                success: ''
            }
        },
        methods: {
            showError(error) {
                for (const message in error) {
                    this.error.push(error[message])
                }
            },

            async updatePassword() {
                this.error = []
                try {
                    await UserService.updatePassword(this.oldPassword, this.newPassword, this.repeatPassword)
                    this.showNotification('success', 'Alert', 'Password succesfully updated!')
                } catch(e) {
                    console.log(e)
                    this.showError(e.networkError.result.errors[0].extensions.validation)
                 }
            }
        },
        computed: {
            userInfo () {
                return this.$store.getters.userInfo
            }
        }
    }
</script>

